module.exports = __webpack_public_path__ + "media/scholarship_winners/cassandra-m-811b8e5c.png";